



export default function MoreButtonLogo({width, height, color, margin}) {
    return (
        <svg width= {width ? width :"20"} height={height ? height :"20"} 
            xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"> 
            <g> 
                <path fill="none" d="M0 0h24v24H0z"/> 
                <path fill= {color ? color : "#999"}
                    d="M5 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm14 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-7 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/> 
            </g> 
        </svg>
    )
}